export const ENTRYPOINT_FILE_ID = 'entrypoint';
export const ENTRYPOINT_FILE_NAME = 'SKILL.md';
